import { render, staticRenderFns } from "./PessoaConexaoEmailForm.vue?vue&type=template&id=82c310f4"
import script from "./PessoaConexaoEmailForm.vue?vue&type=script&lang=js"
export * from "./PessoaConexaoEmailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports